interface AgGridColumnWidthProps {
    text: string;
    font?: string;
    letterSpacing?: number;
    padding?: number;
}

export const getAgGridColumnWidth = ({
    text,
    font = "bold 600 100%",
    letterSpacing = 0.2,
    padding = 74,
}: AgGridColumnWidthProps): number => {
    const getAgGridColumnWidthFunc = getAgGridColumnWidth as { canvas?: HTMLCanvasElement };
    const canvas =
        getAgGridColumnWidthFunc.canvas || (getAgGridColumnWidthFunc.canvas = document.createElement("canvas"));
    canvas.style.letterSpacing = `${letterSpacing}px`;
    const context = canvas.getContext("2d");
    context.font = font;
    const metrics = context.measureText(text);
    const spacing = text.length * (letterSpacing * 3);
    // Add padding and menu option spacing
    return Math.floor(metrics.width + padding + spacing);
};
